<template>
  <div
    v-if="toolTypes"
    class="px-lg-2 user-review position-relative"
    @mouseenter="toggleTools"
    @mouseleave="toggleTools"
  >
    <MultiTools
      v-if="customerIsAdmin && toolTypes"
      :class="{ show: displayTools }"
      class="slide-in"
    >
      <Tool :type="toolTypes.editReview" :id="review.review_id_hash" />
      <Tool :type="toolTypes.viewCustomer" :id="review.customer_hash" />
    </MultiTools>
    <div class="d-flex flex-column">
      <ReviewHeader
        :title="review.name"
        :created-at="review.created_at"
        :img-src="review.profile_image"
        :score="review.score"
        :disabled="review.is_deleted"
      >
        <template #details>
          <CustomerChunk
            :expert-review="true"
            :customer-hash="review.customer_hash"
            class="pb-3"
          />
        </template>
        <template #sub>
          <span class="c-gray l-spacing-half font-size-s font-weight-bold">
            <span class="font-size-xxl"> {{ review.score }}</span>
            {{ scoreOutOfMax }}
          </span>
        </template>
      </ReviewHeader>
      <div class="quote mt-3 pa-0 styled-text">
        {{ review.description }}
      </div>
    </div>
  </div>
</template>

<script>
import { useCustomerStore } from '@/stores/customer'
import { mapState } from 'pinia'
import { defineAsyncComponent } from 'vue'
import ReviewHeader from '../atoms/ReviewHeader.vue'

const CustomerChunk = defineAsyncComponent(
  () => import('@/components/pdp/atoms/CustomerChunk.vue')
)
const MultiTools = defineAsyncComponent(
  () => import('@/components/basic/molecules/MultiTools.vue')
)

const Tool = defineAsyncComponent(
  () => import('@/components/basic/atoms/Tool.vue')
)
const LUCA_MARONI = 'Luca Maroni'

export default {
  components: {
    ReviewHeader,
    Tool,
    MultiTools,
    CustomerChunk
  },
  props: { review: Object },
  data() {
    return {
      displayTools: false,
      toolTypes: null,
      customerChunk: null,
      expertLabel: null
    }
  },
  computed: {
    ...mapState(useCustomerStore, ['customerIsAdmin']),
    scoreOutOfMax() {
      const maxScore = this.review.name === LUCA_MARONI ? 99 : 100
      return this.translate('fe_app_pdp_out_of_x', maxScore)
    }
  },
  methods: {
    toggleTools() {
      this.displayTools = !this.displayTools
    }
  },
  async created() {
    const [
      {
        TYPES: { EDIT_REVIEW, VIEW_CUSTOMER }
      },
      { default: UtilityHelper }
    ] = await Promise.all([
      await import('@/constants/AdminTool'),
      await import('@/services/helpers/UtilityHelper')
    ])

    this.toolTypes = { editReview: EDIT_REVIEW, viewCustomer: VIEW_CUSTOMER }
    this.expertLabel = UtilityHelper.formatString(
      '<span class="link-winered">%s</span>',
      this.review.name
    )
  }
}
</script>

<style scoped>
.user-review:not(:last-child) {
  border-bottom: 2px solid rgb(var(--v-theme-light-beige));
  padding-bottom: 1rem;
  padding-top: 1rem;
}
.user-review:last-child {
  padding-top: 1rem;
}

.admin-tools {
  position: absolute;
  top: 30px;
  right: 0;
}
</style>
